module.exports = __webpack_public_path__ + "static/media/bg_00.970faaf5.png";